const formatEditDate = (t: string) => {
  const date = new Date(t)
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }
  const datePart = date.toLocaleDateString('en-US', options)
  const timePart = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })
  return `${datePart} · ${timePart}`
}

export default formatEditDate
